/**
 * Represent the size of a 2D object, with (width, height)
 */
export class SizeF2D {
    public width: number;
    public height: number;

    constructor(width: number = 0, height: number = 0) {
        this.width = width;
        this.height = height;
    }
}
